const messageSocketEventNamespace = "message-event" as const;
type MessageSocketEventNamespace = typeof messageSocketEventNamespace;
const messageSocketEventTypeNames = [
    "message-created",
    "message-updated",
] as const;
type MessageSocketEventTypeName = (typeof messageSocketEventTypeNames)[number];

export { messageSocketEventNamespace, messageSocketEventTypeNames };
export type { MessageSocketEventNamespace, MessageSocketEventTypeName };
